"use strict";

var _toConsumableArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/toConsumableArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterButton = void 0;

var icons_1 = require("@ant-design/icons");

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

function FilterButton(_ref) {
  var label = _ref.label,
      children = _ref.children,
      value = _ref.value,
      options = _ref.options,
      onChange = _ref.onChange,
      multiple = _ref.multiple,
      hideClear = _ref.hideClear,
      _ref$buttonProps = _ref.buttonProps,
      buttonProps = _ref$buttonProps === void 0 ? {} : _ref$buttonProps;
  var overlay = react_1.default.createElement(antd_1.Menu, {
    selectedKeys: multiple ? value : [value],
    onClick: function onClick(_ref2) {
      var key = _ref2.key;

      if (onChange) {
        if (multiple) {
          var filtered = (value || []).filter(function (item) {
            return item !== key;
          });

          if (filtered.length === (value || []).length) {
            onChange([].concat(_toConsumableArray(value), [key.toString()]));
          } else {
            onChange(filtered);
          }
        } else {
          onChange(key === value ? null : key.toString());
        }
      }
    }
  }, children || options.map(function (option) {
    return react_1.default.createElement(antd_1.Menu.Item, {
      key: option.value
    }, option.label);
  }));
  var arrayValues = value ? Array.isArray(value) ? value : [value] : [];
  var selectedOptions = arrayValues.map(function (val) {
    return options.find(function (opt) {
      return opt.value === val;
    });
  }).filter(Boolean);
  var selectedLabel = selectedOptions.length > 1 ? "".concat(selectedOptions.length, " selected") : selectedOptions[0] ? selectedOptions[0].label : null;
  var buttonInner = selectedOptions.length ? react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("strong", null, label, ": "), react_1.default.createElement("span", null, (selectedLabel === null || selectedLabel === void 0 ? void 0 : selectedLabel.length) && selectedLabel.length > 30 ? "".concat(selectedLabel === null || selectedLabel === void 0 ? void 0 : selectedLabel.slice(0, 30), "...") : selectedLabel)) : "Filter ".concat(label);
  var type = value && value.length > 0 ? 'primary' : undefined;
  return react_1.default.createElement(antd_1.Button.Group, null, react_1.default.createElement(antd_1.Dropdown, {
    overlay: overlay,
    trigger: ['click']
  }, react_1.default.createElement(antd_1.Button, Object.assign({}, buttonProps, {
    type: type
  }), buttonInner)), type && !hideClear ? react_1.default.createElement(antd_1.Button, Object.assign({}, buttonProps, {
    icon: react_1.default.createElement(icons_1.CloseOutlined, null),
    onClick: function onClick() {
      if (onChange) {
        onChange(multiple ? [] : null);
      }
    },
    type: type
  })) : null);
}

exports.FilterButton = FilterButton;